export default __webpack_public_path__ + "static/permisos-e2d85fe35d0cc3082dd33672675a1f7f.png";